import Vue from 'vue';
import VueRouter from 'vue-router';
import SignInPage from '../views/SignInPage.vue';
import CallLogPage from '../views/CallLogPage.vue';
import CustomersTablePage from '../views/CustomersTablePage.vue';
import CustomerFormPage from '../views/CustomerFormPage.vue';
import ReportPage from '../views/ReportPage.vue';
import UsersTablePage from '../views/UsersTablePage.vue';
import UserFormPage from '../views/UserFormPage.vue';
import AdminPage from '../views/AdminPage.vue';
import store from '../store';
import { permissions } from '../permissions';

Vue.use(VueRouter);

const routes = [
  /* Sign In */
  {
    path: '/signin',
    name: 'SignInPage',
    component: SignInPage,
  },
  /* / Sign In */

  /* Call Log */
  {
    path: '/call-log/new',
    name: 'CallLogNewPage',
    component: CallLogPage,
    meta: {
      requiresAuth: true,
      requiresPermissions: [
        'CallsCreate',
      ],
    },
  },
  {
    path: '/call-log/:CallID?',
    name: 'CallLogPage',
    component: CallLogPage,
    meta: {
      requiresAuth: true,
      requiresPermissions: [
        'CallsGetAll',
        'CallsGetByID',
        'CallsUpdate',
        'CallsDelete',
      ],
    },
  },
  /* / Call Log */

  /* Customers */
  {
    path: '/customers',
    name: 'CustomersTablePage',
    component: CustomersTablePage,
    meta: {
      requiresAuth: true,
      requiresPermissions: [
        'CustomersGetAll',
      ],
    },
  },
  {
    path: '/customers/new',
    name: 'CustomerFormNewPage',
    component: CustomerFormPage,
    meta: {
      requiresAuth: true,
      requiresPermissions: [
        'CustomersCreate',
      ],
    },
  },
  {
    path: '/customers/:CustomerID',
    name: 'CustomerFormPage',
    component: CustomerFormPage,
    meta: {
      requiresAuth: true,
      requiresPermissions: [
        'CustomersGetByID',
      ],
    },
  },
  /* / Customers */

  /* Users */
  {
    path: '/users',
    name: 'UsersTablePage',
    component: UsersTablePage,
    meta: {
      requiresAuth: true,
      requiresPermissions: [
        'UsersGetAll',
      ],
    },
  },
  {
    path: '/users/new',
    name: 'UserFormNewPage',
    component: UserFormPage,
    meta: {
      requiresAuth: true,
      requiresPermissions: [
        'UsersCreate',
      ],
    },
  },
  {
    path: '/users/:UserID',
    name: 'UserFormPage',
    component: UserFormPage,
    meta: {
      requiresAuth: true,
      requiresPermissions: [
        'UsersGetByID',
      ],
    },
  },
  /* / Users */

  /* Admin */
  {
    path: '/admin/:tab?',
    name: 'AdminPage',
    component: AdminPage,
    meta: {
      requiresAuth: true,
      requiresPermissions: [
        // Codes Creation Tab
        'CallStatusCreate',
        'CallTypesCreate',
        'CustomerTypesCreate',
        'EmployeeTitlesCreate',
        'SoftwareTypesCreate',
        'PurchasingVendorsCreate',

        // Transaction History Tab
        'HistoryGetAll',
      ],
    },
  },
  /* / Admin */

  /* Report Generator */
  {
    path: '/report',
    name: 'ReportPage',
    component: ReportPage,
    meta: {
      requiresAuth: true,
      requiresPermissions: [
        'CallsGetAll',
      ],
    },
  },
  /* / Report Generator */

  // always redirect to /call-log
  {
    path: '*',
    redirect: '/call-log',
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      permissions
        .isPermittedAtLeastOneAsync(to.meta.requiresPermissions)
        .then((isPermitted) => {
          if (isPermitted) {
            next();
          } else if (from.name) {
            next(false);
          } else {
            next({ name: 'CallLogPage' });
          }
        });

      return;
    }

    let params;

    if (to.params && to.params.requestID) {
      params = to.params;
    }

    store.commit('authError', to);
    next({ name: 'SignInPage', params });
  } else {
    next();
  }
});

export default router;
